module.exports = __webpack_public_path__ + "img/tutorial.8d1661cd.jpg";